module.exports = __webpack_public_path__ + "static/azimo_white-8bbd773cb6b1fe1262bd49c03d6baff4.png";